import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    holidaysData:[]
}

const holidaysSlice = createSlice({
  name: "Holidays",
  initialState: initialState,
  reducers: {
    setHolidays(state, value) {
      state.holidaysData = value.payload;
    }
  },
});

export const { setHolidays} = holidaysSlice.actions;

export default holidaysSlice.reducer;